/**
 * Created by mh on 2017/8/6.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { observer } from 'mobx-react';
import AssetTableRowComponent from './AssetTableRow';

const BuildedHeaderColumns = ({ columns }) => columns.map((column, index) => (
    <th key={index}>
        {column.i18n ? <FormattedMessage id={column.i18n} defaultMessage={column.name} /> : column.name}
    </th>));

@observer
class AssetTable extends React.Component {
    render() {
        const { assets, columns } = this.props;

        return (
            <div className="table-responsive">
                <table className="table table-sm table-striped table-delivermedia">
                    <thead>
                        <tr>
                            <BuildedHeaderColumns columns={columns} />
                            <th>
                                <FormattedMessage id="Assets.Actions" defaultMessage="Actions" />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {assets ?
                            assets.map(asset => (<AssetTableRowComponent
                                asset={asset}
                                columns={columns}
                                key={asset.id} />))
                            : (
                                <tr>
                                    <td>
                                        <FormattedMessage id="Assets.NoAssetsFound" defaultMessage="No assets found" />
                                    </td>
                                </tr>
                            )}
                    </tbody>
                </table>
            </div>);
    }
}

AssetTable.propTypes = {
    assets: PropTypes.object.isRequired,
    columns: PropTypes.array.isRequired,
};

export default injectIntl(AssetTable);
